import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Accessibility, Car, Bath } from 'lucide-react';

const AccessibilitySection = () => {
  const { t } = useLanguage();

  const features = [
    {
      icon: Accessibility,
      title: t('accessibility.wheelchair'),
    },
    {
      icon: Car,
      title: t('accessibility.parking'),
    },
    {
      icon: Bath,
      title: t('accessibility.restroom'),
    },
  ];

  return (
    <section 
      id="accessibility"
      className="section-padding bg-earth/30 relative overflow-hidden"
      aria-labelledby="accessibility-title"
    >
      <div className="container-main">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-12">
          <span 
            className="inline-block font-body text-sm uppercase tracking-widest font-semibold text-sage mb-4"
            data-testid="accessibility-caption"
          >
            {t('accessibility.caption')}
          </span>
          <h2 
            id="accessibility-title"
            className="font-heading text-4xl md:text-5xl font-semibold text-[#1C1C1E] tracking-tight mb-6"
            data-testid="accessibility-title"
          >
            {t('accessibility.title')}
          </h2>
          <p 
            className="font-body text-lg text-muted-foreground leading-relaxed"
            data-testid="accessibility-statement"
          >
            {t('accessibility.statement')}
          </p>
        </div>

        {/* Accessibility Features */}
        <div className="flex flex-wrap justify-center gap-8">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="flex items-center gap-4 bg-white/80 backdrop-blur-sm rounded-full px-8 py-4 shadow-md hover:shadow-lg transition-shadow duration-300"
              data-testid={`accessibility-feature-${index}`}
            >
              <div className="accessibility-icon w-12 h-12 rounded-full flex items-center justify-center">
                <feature.icon className="w-6 h-6 text-white" aria-hidden="true" />
              </div>
              <span className="font-body font-semibold text-[#1C1C1E]">
                {feature.title}
              </span>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default AccessibilitySection;
